import axios from "axios";
import {
  FetchFlightTripDetailsRequestV2,
  FetchFlightTripDetailsResponseV2,
} from "@capone/packages-api";
import { config } from "../../config";

import { flightTripDetailsApiPath } from "../paths";

export const fetchFlightTripDetailsV2 = (
  body: FetchFlightTripDetailsRequestV2
): Promise<FetchFlightTripDetailsResponseV2> =>
  axios
    .post(flightTripDetailsApiPath, body, {
      baseURL: config.baseURL,
    })
    .then((res) => {
      if (res.data.Response === "Success") {
        return res.data.value;
      }
      throw res.data.error;
    });
